/*
  AUTHOR - KHYATI RADADIYA
  COMPANY NAME - RADIX ANALYTICS
  Version - 1
  Change log
    ---------------------------------------------------------------
    Date         Author   Comment
    ---------------------------------------------------------------
    2024-02-22	  Khyati   This is reporting head list reducer file
*/

import {
  GET_REPORTING_USER_REQUEST,
  GET_REPORTING_USER_SUCCESS,
  GET_REPORTING_USER_FAILURE,
} from "../../actions/types";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const GetReportingUser = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORTING_USER_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_REPORTING_USER_SUCCESS:
      return { ...state, data: action.payload, loading: false, error: null };
    case GET_REPORTING_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default GetReportingUser;
